<template>
  <div class="subprogram-nba-summary-teams" v-loading="loading">
    <!-- Conferences -->
    <div
      class="subprogram-nba-summary-teams__conference"
      v-for="conference in Object.values(conferences)"
      :key="conference.id"
    >
      <!-- Header -->
      <div class="subprogram-nba-summary-teams__conference__header">
        <span
          class="subprogram-nba-summary-teams__conference__header__title"
          v-text="conference.title"
        />
        <span
          class="subprogram-nba-summary-teams__conference__header__teams"
          v-text="getNumTeamsPerConference(conference) + ' ' + i18n('entities.subprogram.nba.conference.teams')"
        />
      </div>

      <!-- Divisions -->
      <div
        class="subprogram-nba-summary-teams__divisions"
      >
        <div
          class="subprogram-nba-summary-teams__divisions__card"
          v-for="(division, i) in Object.values(conference.divisions)"
          :key="`subprogram-nba-summary-teams__divisions__card__col--${i}`"
          :span="8"
        >

        <div class="subprogram-nba-summary-teams__divisions__card__title">
          <span
            v-text="division.title"
          />
        </div>

          <!-- Teams -->
          <div
            v-for="team in Object.values(division.teams)"
            :class="team.isMatched ? 'subprogram-nba-summary-teams__divisions__card__teams--matched':'subprogram-nba-summary-teams__divisions__card__teams'"
            :key="team.id"
            @click="team.isMatched ? $router.push({ name: 'SubprogramNbaSchoolTeamView', params: { programId, subprogramId, teamId: team.id, tabName: 'summary' }}) : null"
          >
            <!-- Logo -->
            <div
              class="subprogram-nba-summary-teams__divisions__card__teams__logo"
              :style="{ backgroundImage: `url(${team.imageUrl})` }"
            />

            <!-- Name -->
            <span
              v-text="team.name"
              :class="team.isMatched  ? 'subprogram-nba-summary-teams__divisions__card__teams--matched__name':'subprogram-nba-summary-teams__divisions__card__teams__name'"
            />

            <!-- School name -->
            <span
              v-if="team.schoolName && team.isMatched"
              v-text="team.schoolName"
              class="subprogram-nba-summary-teams__divisions__card__teams__school"
            />
            <!-- To match button -->
            <!-- NO match and regular season configured  -->
            <router-link
              v-if="!team.isMatched"
              class="subprogram-nba-summary-teams__divisions__card__teams__router"
              :to="{ name: 'SubprogramNbaSchoolTeamNew', params: { programId, subprogramId, teamId: team.id }}"
            >
              <el-button
                type="primary"
                class="subprogram-nba-summary-teams__divisions__card__teams__router__button"
                v-text="i18n('entities.subprogram.nba.conference.pairing')"
              />
            </router-link>

            <!-- Matched succes -->
            <i v-else-if="team.isMatched" class="subprogram-nba-summary-teams__divisions__card__teams--matched__icon icon-tick"></i>

            <!-- Un matched lock -->
            <!-- NO match and NO regular season configured  -->
            <div
              v-else-if="!team.isMatched && isRegularSeasonConfigured"
              class="subprogram-nba-summary-teams__divisions__card__teams--unmatched"
            >
              <el-tooltip 
                class="item" 
                effect="dark" 
                :content="i18n('common.unmatched')" 
                placement="bottom-end"
              >
                <i 
                  class="subprogram-nba-summary-teams__divisions__card__teams--unmatched__icon icon-cross"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { i18n } from '@shared/i18n'

  export default {
    name: 'app-subprogram-nba-summary-teams',
    computed: {
      ...mapGetters({
        loading: 'subprogram/nba/summary/loading',
        conferences: 'subprogram/nba/summary/conferences',
        programId: 'subprogram/nba/programId',
        subprogramId: 'subprogram/nba/subprogramId',
        subprogram: 'subprogram/nba/subprogram'
      }),
      isRegularSeasonConfigured() {
        return get(this, 'subprogram.regularSeasonConfigured', false);
      }
    },

    methods: {
      i18n(key) {
        return i18n(key);
      },
      getNumTeamsPerConference(conferenceMap) {
        return Object.values(conferenceMap.divisions).reduce(( acum, { teams } ) => {
          return Object.values(teams).length + acum;
        }, 0)
      },
    },
  }
</script>

<style lang="scss" scoped>
.subprogram-nba-summary-teams {
  display: grid;
  grid-row-gap: 40px;

  &__conference {
    &__header {
      display: grid;
      grid-template-areas: 'title teams';
      align-content: center;
      justify-content: space-between;
      &__title {
        font-size: 18px;
        color: #4c4c4c;
        text-transform: uppercase;
      }
      &__teams {
        font-size: 18px;
        color: #4c4c4c;
        text-transform: uppercase;
        font-weight: bold;
      }
    }
  }
  &__divisions {
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 16px;
    // background-color: red;
    &__card {
      margin-top: 24px;
      box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
      background-color: #f8f8f8;

      &__title {
        padding: 24px;
        background-color: #ffffff;
        color: rgba(102, 102, 102, 0.74);
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &__teams {
        display: grid;
        grid-template-areas: 'logo name button';
        align-items: center;
        grid-template-columns: 40px 4fr 2fr;
        grid-auto-rows: 70px;
        padding: 0px 14px;
        grid-column-gap: 5px;
  
        &__logo {
          grid-area: logo;
          width: 40px;
          height: 40px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          // border-radius: 100%;
        }
        &__name {
          grid-area: name;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: uppercase;
          color: #404040;
          max-height: 1.6em;
          line-height: 1.8em;
        }
        &__school {
          grid-area: school;
          font-size: 12px;
          align-self: flex-start;
          color: #979797;
          overflow: hidden; 
          text-overflow: ellipsis;
        }
        &__router {
          grid-area: button;
          justify-self: end;

          &__button {
            color: #fff;
            font-size: 12px;
            padding: 0;
            height: 30px;
            width: 80px;
            border-radius: 14px;
            text-transform: capitalize;
            color: #6d7278;
            font-weight: 500;
          }
        }
        &--unmatched {
          display: flex;
          justify-self: center;
          color: #ffcd07;
          justify-self: end;
          &__icon {     
            font-size: 12px;
            color: #999999;
          }
        }
        &--matched {
          display: grid;
          grid-template-areas: 'logo name icon' 'logo school icon';
          align-items: center;
          grid-template-columns: 40px 4fr 2fr;
          grid-auto-rows: 40px 30px;
          padding: 0px 14px;
          background-color: #ffffff;
          border-top: 1px solid #f8f8f8;
          border-bottom: 1px solid #f8f8f8;
          grid-column-gap: 5px;
          cursor: pointer;
          justify-self: end;

          &__name {
            align-self: flex-end;
            overflow: hidden;
            text-overflow: ellipsis;     
            text-transform: uppercase;
            color: #404040;
            max-height: 1.6em;
            line-height: 1.8em;
          }
          &__icon {
            grid-area: icon;
            justify-self: center;
            color: #2acccc;
            justify-self: end;
          }
        }
      }
    }
  }

  .el-button {
    font-size: 12px;
    padding: 0;
    height: 30px;
    width: 80px;
    border-radius: 14px;
    text-transform: capitalize;
    color: #fff;
    font-weight: 500;
  }
}
</style>
